function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
export default {
  name: 'FormSomos1ReportComponent',
  props: {
    item: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      valid: false,
      report: {},
      readonly: false,
      isOrganizationReport: false,
      organizations: [],
      sectionValues: ['Somos1', 'Empresas'],
      tags_global: []
    };
  },
  created: function created() {
    if (this.item) {
      this.report = this.item;
      if (this.item.section === this.sectionValues[1]) {
        this.isOrganizationReport = true;
      }
      this.changeSection();
    }
    this.getOrganizations();
  },
  methods: {
    getOrganizations: function getOrganizations() {
      var _this = this;
      domainService.getOrganizationsDetail().then(function (response) {
        if (response.success && response.code === 200) {
          response.data.forEach(function (x) {
            _this.organizations.unshift({
              name: x.alias,
              id: x.code
            });
          });
        }
      });
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      this.$emit('SubmitReport', this.report);
    },
    itemText: function itemText(item) {
      return item.region;
    },
    itemValue: function itemValue(item) {
      return item;
    },
    orgText: function orgText(item) {
      return item.name;
    },
    orgValue: function orgValue(item) {
      return item;
    },
    changeSection: function changeSection() {
      if (this.report.section === this.sectionValues[1]) {
        // Organizations
        this.isOrganizationReport = true;
        this.tags_global = this.tags_org;
      } else {
        this.isOrganizationReport = false;
        this.tags_global = this.tags;
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('customer-insights', ['regions', 'sections', 'tags', 'tags_org', 'updateHours'])), {}, {
    rules: function rules() {
      var _this2 = this;
      return {
        general: [function (v) {
          return !!v || _this2.translate('reglas.field');
        }],
        updateHours: [function (v) {
          return !!v.length || _this2.translate('reglas.field');
        }, function (v) {
          return v.length >= 2 || _this2.translate('reglas.insights_min_2_update_hours');
        }],
        report_tool: [function (v) {
          return !!v || _this2.translate('reglas.field');
        }]
      };
    }
  })
};